import { useCallback, useState } from 'react';
import { useForm } from 'react-final-form';

export type SectionRow = {
  id: string;
  title: string;
  description: string;
  button_copy: string;
  show_button: boolean;
  cta_button_color: string | null;
  redirect_link: string;
  layout: 'IMAGE_LEFT' | 'IMAGE_RIGHT' | 'IMAGE_CENTER_TOP' | 'IMAGE_CENTER_BOTTOM' | 'NO_IMAGE';
  background_color: string | null;
  text_color: string | null;
  image_file?: File;
  has_image?: boolean;
  previewSection?: string;
  collapsed?: boolean;
};

export const createEmptySection = (): SectionRow => ({
  id: `${Date.now()}`,
  title: '',
  description: '',
  button_copy: '',
  show_button: true,
  cta_button_color: null,
  redirect_link: '',
  layout: 'NO_IMAGE',
  background_color: null,
  text_color: null,
  image_file: undefined,
  has_image: false,
  previewSection: undefined,
  collapsed: false,
});

export const useDragAndDrop = (sections: SectionRow[]) => {
  const { change } = useForm();
  const [draggingId, setDraggingId] = useState<string | null>(null);

  const handleDragStart = useCallback((id: string) => {
    setDraggingId(id);
  }, []);

  const handleDragOver = useCallback(
    (event: React.DragEvent, id: string) => {
      event.preventDefault();
      if (draggingId === id) return;
      const draggedIndex = sections.findIndex(row => row.id === draggingId);
      const targetIndex = sections.findIndex(row => row.id === id);
      if (draggedIndex === -1 || targetIndex === -1) return;
      const updated = [...sections];
      const [draggedRow] = updated.splice(draggedIndex, 1);
      updated.splice(targetIndex, 0, draggedRow);
      change('sections', updated);
    },
    [draggingId, sections]
  );

  const handleDragEnd = useCallback(() => {
    setDraggingId(null);
  }, []);

  return { draggingId, handleDragStart, handleDragOver, handleDragEnd };
};
